"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eight/sections/aboutSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type AboutSection6sItem = {
    key: Key | null | undefined;
    /** Detected variants: "Mission" | "Vision" */
    h30Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/service/about-icon-1.svg" | "/Templates/Doccure/img/service/about-icon-2.svg" */
    src: string;
    /** Detected variants: "To deliver advanced, compassionate eye care using innovative technology, skilled specialists" | "To be a leading eye care center for world-class clinical excellence, patient-focused care" */
    p0Text: ReactNode;
    /** Detected variants: "col-lg-6" */
    className?: string;
    /** Detected variants: "about-item" */
    div0ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "about-icon-1" */
    alt?: string;
    /** Detected variants: "img-fluid img-1" */
    imageWithBasePath0ClassName?: string;
};
export type HomeEightAboutSectionGeneratedProps = {
    /** Default: "About Doccure Eyecare" */
    text?: string;
    divDiv0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: AboutSection6sItem) => Partial<ComponentProps<"h3">>);
    divDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSection6sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    /** Default: "1s" */
    sectionDataWowDuration?: string;
    sectionDiv0Div0ClassName?: string;
    /** Default: "text" */
    sectionDiv0Div0Div0Div0Button0ButtonDataText?: string;
    sectionDiv0Div0Div0Div0Button0ButtonVisible?: boolean;
    sectionDiv0Div0Div0Div0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "Years of Experience" */
    sectionDiv0Div0Div0Div0H40H4Text?: ReactNode;
    sectionDiv0Div0Div0Div0H40H4Visible?: boolean;
    sectionDiv0Div0Div0Div0H40H4Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H40H4Props?: Partial<ComponentProps<"h4">>;
    /** Default: "12+" */
    sectionDiv0Div0Div0Div0H40Span0SpanText?: ReactNode;
    /** Default: "about-img" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/about-img-3.png" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "About Us" */
    sectionDiv0Div0Div1Div0Div0DivText?: ReactNode;
    /** Default: "Compassionate care to provide" */
    sectionDiv0Div0Div1Div0H20H2Text?: ReactNode;
    /** Default: "the quality" */
    sectionDiv0Div0Div1Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0Div1Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div1Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "eye care services. " */
    sectionDiv0Div0Div1Div0H20Span0SpanText?: ReactNode;
    /** Default: "Our state-of-the-art facility is equipped with the latest diagnostic and treatment technology, ensuring accurate diagnoses and effective treatment plans." */
    sectionDiv0Div0Div1Div0P0PText?: ReactNode;
    sectionDiv0Div0Div1Div1ClassName?: string;
    /** Default: "#" */
    sectionDiv0Div0Div1Div2Link0LinkHref?: string;
    /** Default: "View All Services" */
    sectionDiv0Div0Div1Div2Link0LinkText?: ReactNode;
    sectionDiv0Div0Div1Div2Link0LinkVisible?: boolean;
    sectionDiv0Div0Div1Div2Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div2Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    aboutSection6s: AboutSection6sItem[];
    aboutSection6sItemWrapper?: (item: AboutSection6sItem, content: ReactNode) => ReactNode;
    aboutSection6sRenderer?: (defaultNode: ReactNode) => ReactNode;
    aboutSection6sImageVisible?: boolean;
    aboutSection6sImageRenderer?: (item: AboutSection6sItem, defaultNode: ReactNode) => ReactNode;
    aboutSection6sH3Visible?: boolean;
    aboutSection6sH3Renderer?: (item: AboutSection6sItem, defaultNode: ReactNode) => ReactNode;
    aboutSection6sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSection6sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    aboutSection6sH3Props?: Partial<ComponentProps<"h3">> | ((item: AboutSection6sItem) => Partial<ComponentProps<"h3">>);
};

const HomeEightAboutSectionGenerated: FC<HomeEightAboutSectionGeneratedProps> = ({
    text: textProp = "About Doccure Eyecare",
    sectionDataWowDuration = "1s",
    sectionDiv0Div0Div0Div0Button0ButtonDataText = "text",
    sectionDiv0Div0Div0Div0Button0ButtonVisible,
    sectionDiv0Div0Div0Div0Button0ButtonRenderer,
    sectionDiv0Div0Div0Div0Button0ButtonProps,
    sectionDiv0Div0Div0Div0H40H4Text = "Years of Experience",
    sectionDiv0Div0Div0Div0H40H4Visible,
    sectionDiv0Div0Div0Div0H40H4Renderer,
    sectionDiv0Div0Div0Div0H40H4Props,
    sectionDiv0Div0Div0Div0H40Span0SpanText = "12+",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt = "about-img",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/about-img-3.png",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0Div0DivText = "About Us",
    sectionDiv0Div0Div1Div0H20H2Text = "Compassionate care to provide",
    sectionDiv0Div0Div1Div0H20H2Text2 = "the quality",
    sectionDiv0Div0Div1Div0H20H2Visible,
    sectionDiv0Div0Div1Div0H20H2Renderer,
    sectionDiv0Div0Div1Div0H20H2Props,
    sectionDiv0Div0Div1Div0H20Span0SpanText = "eye care services. ",
    sectionDiv0Div0Div1Div0P0PText = "Our state-of-the-art facility is equipped with the latest diagnostic and treatment technology, ensuring accurate diagnoses and effective treatment plans.",
    sectionDiv0Div0Div1Div2Link0LinkHref = "#",
    sectionDiv0Div0Div1Div2Link0LinkText = "View All Services",
    sectionDiv0Div0Div1Div2Link0LinkVisible,
    sectionDiv0Div0Div1Div2Link0LinkRenderer,
    sectionDiv0Div0Div1Div2Link0LinkProps,
    divDiv0H30H3Props,
    divDiv0ImageWithBasePath0ImageProps,
    sectionDiv0Div0ClassName,
    sectionDiv0Div0Div1Div1ClassName,
    aboutSection6s,
    aboutSection6sItemWrapper,
    aboutSection6sRenderer,
    aboutSection6sImageVisible,
    aboutSection6sImageRenderer,
    aboutSection6sH3Visible,
    aboutSection6sH3Renderer,
    aboutSection6sImageProps,
    aboutSection6sH3Props,
}) => {
    const text = textProp;
    const chars = text.split("");
    const angle = 360 / chars.length;
    return (
        <section className="about-section-eight section wow fadeInUp" data-wow-duration={sectionDataWowDuration}>
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row align-items-center"}>
                    <div className="col-lg-6">
                        <div className="about-img">
                            {renderNode(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                            {renderNode(sectionDiv0Div0Div0Div0H40H4Visible, sectionDiv0Div0Div0Div0H40H4Renderer, (
                                <h4 className="rotate-text" {...(sectionDiv0Div0Div0Div0H40H4Props ?? {})}>
                                    {" "}
                                    <span className="text-gradient">{sectionDiv0Div0Div0Div0H40Span0SpanText}</span>
                                    {sectionDiv0Div0Div0Div0H40H4Text}
                                </h4>
                            ))}
                            {renderNode(sectionDiv0Div0Div0Div0Button0ButtonVisible, sectionDiv0Div0Div0Div0Button0ButtonRenderer, (
                                <button className="animate-button" data-text={sectionDiv0Div0Div0Div0Button0ButtonDataText} {...(sectionDiv0Div0Div0Div0Button0ButtonProps ?? {})}>
                                    <p className="button-text">
                                        {chars.map((char, index) => (
                                            <span
                                                key={index}
                                                style={
                                                    {
                                                        "--index": index,
                                                        "--angle": angle,
                                                    } as React.CSSProperties
                                                }
                                            >
                                                {char}
                                            </span>
                                        ))}
                                    </p>
                                    <span className="button-circle" />
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-6 ps-lg-5">
                        <div className="section-header section-header-eight">
                            <div className="section-sub-title">
                                <span className="dot" />
                                {sectionDiv0Div0Div1Div0Div0DivText}
                            </div>
                            {renderNode(sectionDiv0Div0Div1Div0H20H2Visible, sectionDiv0Div0Div1Div0H20H2Renderer, (
                                <h2 className="section-title" {...(sectionDiv0Div0Div1Div0H20H2Props ?? {})}>
                                    {sectionDiv0Div0Div1Div0H20H2Text}
                                    <br />
                                    {sectionDiv0Div0Div1Div0H20H2Text2}
                                    {" "}
                                    <span className="line">{sectionDiv0Div0Div1Div0H20Span0SpanText}</span>
                                </h2>
                            ))}
                            <p className="para">{sectionDiv0Div0Div1Div0P0PText}</p>
                        </div>
                        <div className={sectionDiv0Div0Div1Div1ClassName ?? "row g-4"}>
                            {renderCollectionNode(
                                aboutSection6s,
                                (item: AboutSection6sItem) => (
                                    <div className={item.className ?? "col-lg-6"} key={item.key}>
                                        <div className={item.div0ClassName ?? "about-item"}>
                                            {renderItemNode(aboutSection6sH3Visible, aboutSection6sH3Renderer, item, (
                                                <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof aboutSection6sH3Props === "function" ? aboutSection6sH3Props(item) : (aboutSection6sH3Props ?? {}))} {...(typeof divDiv0H30H3Props === "function" ? divDiv0H30H3Props(item) : (divDiv0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                            ))}
                                            <p>{item.p0Text}</p>
                                            {renderItemNode(aboutSection6sImageVisible, aboutSection6sImageRenderer, item, (
                                                <SmartImage src={item.src} alt={item.alt ?? "about-icon-1"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-1"} {...(typeof aboutSection6sImageProps === "function" ? aboutSection6sImageProps(item) : (aboutSection6sImageProps ?? {}))} {...(typeof divDiv0ImageWithBasePath0ImageProps === "function" ? divDiv0ImageWithBasePath0ImageProps(item) : (divDiv0ImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                        </div>
                                    </div>
                                ),
                                aboutSection6sItemWrapper,
                                aboutSection6sRenderer
                            )}
                        </div>
                        <div className="view-all">
                            {renderNode(sectionDiv0Div0Div1Div2Link0LinkVisible, sectionDiv0Div0Div1Div2Link0LinkRenderer, (
                                <SmartLink href={sectionDiv0Div0Div1Div2Link0LinkHref} className="btn btn-primary theme-8-btn" {...(sectionDiv0Div0Div1Div2Link0LinkProps ?? {})}>
                                    <span className="icon">
                                        <i className="isax isax-arrow-right-3" />
                                    </span>
                                    {sectionDiv0Div0Div1Div2Link0LinkText}
                                </SmartLink>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeEightAboutSectionGenerated;
